(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.promotion = {
    attach: function (context) {
      $('.slick__slider').on('init afterChange', function (event, slick, currentSlide) {
        var current = (currentSlide || 0) + 1;
        var total = slick.slideCount;
        $(this).find('.slick-current .slide-counter-i').text(current);
        $(this).find('.slick-current .slide-counter-total').text(total);
      });

      // Promotion Items Action Link. Mobile.
      $('.promotion-main-items-mobile .items-list').on('change', function () {
        const url = this.value;
        if (url) {
          window.location.href = url;
        }
      });

    },
  };

})(jQuery, Drupal);
